module.exports = __webpack_public_path__ + "img/cascata_02.7f099764.jpg";